import { TableCell } from '@material-ui/core';
import React from 'react';
import VoxelLink from '../../../../../components/voxel/Link/VoxelLink';
import VoxelTooltipShort from '../../../../../components/voxel/Tooltip/VoxelTooltipShort';
import { ContentActionGq } from '../../../../../graphql/projects/models/ContentActionGq';
import { ContentTaskGq } from '../../../../../graphql/projects/models/ContentTaskGq';
import { getTaskUrl } from './TaskUrl';

export interface TableCellUrlIconProps {
  contentTask: ContentTaskGq;
  clientUrl: string;
}

const TableCellUrl: React.FC<TableCellUrlIconProps> = React.memo(({ contentTask, clientUrl }) => {
  return (
    <TableCell className="max-w-[300px] whitespace-nowrap truncate">
      <VoxelTooltipShort message={contentTask.url} placement="top">
        <div
          className={`${contentTask.actionFinal === ContentActionGq.CREATE ? 'text-voxel-gray-500' : ''
            }`}
        >
          {getTaskUrl(contentTask.url, clientUrl)}
          {contentTask.actionFinal !== ContentActionGq.CREATE && (
            <VoxelLink href={contentTask.url} openInNewTab openInNewIcon />
          )}
        </div>
      </VoxelTooltipShort>
    </TableCell>
  );
});

export default TableCellUrl;
